import React from 'react';
import CoreNewsItemView from '@plone/volto/components/theme/View/NewsItemView';
import NewsSEO from '../SEO/NewsSEO';

/**
 * News Item detail view override.
 *
 * Renders core's `NewsItemView` unchanged and adds only the `<title>` suffix
 * fix (see NewsSEO) — same shape as `DocumentView` wrapping `DocumentSEO` and
 * `FileDetailView` wrapping core's `FileView`. Registered against the `News
 * Item` portal type in index.ts's `config.views.contentTypesViews`, the exact
 * key core's own `config/Views.jsx` registers `NewsItemView` under.
 */
const NewsItemView = (props) => (
  <>
    <NewsSEO content={props.content} />
    <CoreNewsItemView {...props} />
  </>
);

export default NewsItemView;
